import { ChannelEnum, ProductCustomPriceTypeEnum } from "@c2b/muven-commons";

export class ProductFormChannelInfoForm {
    id?: string = undefined;
    name: string = '';
    enumChannel: ChannelEnum;
    customPriceType: ProductCustomPriceTypeEnum = ProductCustomPriceTypeEnum.Percentage;
    sellPrice: number|null = null;    
    listPrice: number|null = null;
    pricePercentage: number|null = null;
    priceDecimalsPreference: string|null = null;
    availableStockPercentage: number|null = null;
    priceUponRequest?: boolean|null = null;
    hasMinimalStock: boolean = false;
    minimalStock: number = 0;
    isActive: boolean = true;
    validInChannel: boolean = true;
    idExternalChannel? : string|null = null;
    isMercadoLivre: boolean = false;
    idProductStoreChannel: string|null = null;
    collapsed: boolean = true;
    stockAvailability: number|null = null;

    constructor(c?:Partial<ProductFormChannelInfoForm>) {
        Object.assign(this, c)
    }

    isPriceTypePercentage():boolean {
        return this.customPriceType === ProductCustomPriceTypeEnum.Percentage
    }

    isPriceTypeValue():boolean {
        return this.customPriceType === ProductCustomPriceTypeEnum.Value
    }

    updatePriceType(type:ProductCustomPriceTypeEnum):void {
        this.customPriceType = type
    }
}
